import { BaseElement, defineElement } from '@webtides/element-js';

class AnimateScrollEntrance extends BaseElement {
    animationClass(animation) {
        const legacyAnimations = {
            fade: 'animate__fadeIn',
            fromLeft: 'animate__fadeInLeft',
            fromRight: 'animate__fadeInRight',
            fromTop: 'animate__fadeInDown',
            fromBottom: 'animate__fadeInUp',
        };

        return legacyAnimations[animation] ?? animation;
    }

    properties() {
        return {
            rootMargin: '0px 0px -200px 0px',
            threshold: 0,
            entranceAnimation: 'animate__fadeInUp',
            leaveAnimation: 'animate__fadeOut',
            delay: 100,
            hasEntered: false,
            animatedOnce: true,
            animateSelector: '[animate]',
        };
    }

    connected() {
        this.$elementToAnimate = this.querySelector(this.animateSelector) || this.firstElementChild;
        this.$elementToAnimate.style.setProperty('opacity', '0');

        // reset animation state, for example to avoid bugs with the z-index etc.
        this.$elementToAnimate.style.animationFillMode = 'none';

        this._intersectionObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.hasEntered) {
                        this.enter();
                    } else if (!entry.isIntersecting && this.hasEntered) {
                        this.leave();
                    }
                });
            },
            {
                rootMargin: this.rootMargin,
                threshold: this.threshold,
            }
        );

        this._intersectionObserver.observe(this);
    }

    leave() {
        if (this._enterTimeout) {
            clearTimeout(this._enterTimeout);
        }
        this.hasEntered = false;

        this.$elementToAnimate.classList.remove(this.animationClass(this.entranceAnimation));
        this.$elementToAnimate.classList.add(this.leaveAnimation);

        this._leaveTimeout = setTimeout(() => {
            this.$elementToAnimate.style.setProperty('opacity', '0');
            this.$elementToAnimate.classList.remove('animate__animated');
        }, 1000);

        this._enterTimeout && clearTimeout(this._enterTimeout);
    }

    enter() {
        if (this._leaveTimeout) {
            clearTimeout(this._leaveTimeout);
        }

        this.hasEntered = true;

        this._enterTimeout = setTimeout(() => {
            this.$elementToAnimate.classList.add('animate__animated');
            this.$elementToAnimate.classList.remove(this.leaveAnimation);
            this.$elementToAnimate.classList.add(this.animationClass(this.entranceAnimation));
            this.$elementToAnimate.style.removeProperty('opacity');

            if (this.animatedOnce) this._intersectionObserver.unobserve(this);
        }, this.delay);
    }
}

defineElement('animate-scroll-entrance', AnimateScrollEntrance);
